import { render, staticRenderFns } from "./UnlayerEmailConfirmation.vue?vue&type=template&id=1923a56e"
import script from "./UnlayerEmailConfirmation.vue?vue&type=script&lang=js"
export * from "./UnlayerEmailConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports